import event from '@drivesally/sally-fw/lib/event/event';

export default event('/events/accidents/start-new-accident-flow');
